import { getTasks } from '../../api';
import { useListFetch } from '../../hooks';
import { splitCamelCase } from '../../utilities';
import type { TaskResponse, GetTasksPayload } from '../../api';

export type FiltersType = GetTasksPayload['filters'];
export type ItemType = TaskResponse & {
  task_type_enum: string;
};

export const useTasks = () => {
  return useListFetch<ItemType, FiltersType>(
    async params => {
      const result = await getTasks({
        sort: params.sortStr,
        page: params.pagination,
        filters: params?.filters || {},
      });

      return {
        total: result.total,
        content: result.items.map(item => ({
          ...item,
          task_type_enum: item.task_type,
          task_type: splitCamelCase(item.task_type),
        })),
      };
    },
    {
      initialPageSize: 50,
      initialFilters: { campaignId: '', status: '', search: '' },
      withQueryParams: true,
      storageKey: 'use-tasks-list',
    }
  );
};
